import PropTypes from 'prop-types';
import React from 'react';

import RouterLink, {
  RouterLinkProps,
} from 'app/common/components/singlespa/router-link';

// Should be used if component is shared between classic and gamma
// Checks if the component is connected to redux store
// If it's connected then we can use RouterLink
// If it's not conencted we can just use a regular link
export class LinkWrapper extends React.Component<RouterLinkProps> {
  static contextTypes = {
    store: PropTypes.object,
  };

  render() {
    const { children, href, ...props } = this.props;
    let pathname;

    try {
      pathname = new URL(href || '').pathname;
    } catch (e) {
      pathname = href;
    }

    return this.context.store ? (
      <RouterLink href={pathname} {...props}>
        {children}
      </RouterLink>
    ) : (
      <a href={href} {...props}>
        {children}
      </a>
    );
  }
}
